import React, {createContext, useState, useContext, useEffect} from 'react'
import NewsletterModal from "../components/organisms/Modals/NewsletterModal/NewsletterModal";

const defaultValues = {
  showAdditionalMenu: false,
  setShowAdditionalMenu: () => {
  },
}

const AppWrappedContext = createContext(defaultValues)

export const useAppWrapped = () => useContext(AppWrappedContext)

const isUnsubscribed = () => {
  const searchParams = new URLSearchParams(window.location.search)
  const unsubscribeSearchParam = searchParams.get('unsubscribe');
  const emailSearchParam = searchParams.get('email');
  const resubscribeSearchParam = searchParams.get('resubscribe');

  return {
    isUnsubscribed: !!(resubscribeSearchParam && (unsubscribeSearchParam && unsubscribeSearchParam === "true") && emailSearchParam),
    resubscribeLink: resubscribeSearchParam
  };
}

export function AppWrappedProvider({children}) {
  const [showAdditionalMenu, setShowAdditionalMenu] = useState(false)
  const [modalNewsletter, setModalNewsletter] = useState({isOpen: false})

  const onCloseModal = () => {
    setModalNewsletter(prev => ({...prev, isOpen: false}))
  }

  useEffect(() => {
    const {isUnsubscribed: isUnsubscribedKlaviyo, resubscribeLink} = isUnsubscribed();

    setModalNewsletter(prev => ({...prev, resubscribeLink, isOpen: isUnsubscribedKlaviyo}))
  }, [])

  return (
    <AppWrappedContext.Provider value={{showAdditionalMenu, setShowAdditionalMenu}}>
      <NewsletterModal isOpen={modalNewsletter.isOpen} resubscribeLink={modalNewsletter?.resubscribeLink}
                       onClose={onCloseModal}/>
      {children}
    </AppWrappedContext.Provider>
  )
}
